/*eslint no-useless-constructor: "error"*/
"use strict";
import { MemberModel } from "@/models/member-model";

export class MessageBoardModel {
  constructor(json) {
    this.init();
    if (json) {
      this.initWithJson(json);
    }
  }
  init() {
    this.message = "";
    this.name = "";
    this.color = 0
    this.member = null
  }
  initWithJson(json) {
    this.message = json["message"];
    this.color = json["color"];
    this.creatTime = json["creatTime"];
    if (json["member"]) {
      this.member = new MemberModel(json["member"]);
      if (this.member.nickName) {
        this.name = this.member.nickName
      } else {
        this.name = this.member.firstName + this.member.lastName
      }
    }
  }
  get save() {
    return {
      message: this.message,
      color: this.color
    }
  }
}
